import { default as Chained } from 'i18next-chained-backend';
import { HttpApi } from '../http-api';
import { InstanceFactoryOptions } from './types';
import { LocalStorage } from '../local-storage';

/**
 * Создает инстанс `i18n-backend` с 'i18next-localstorage-backend'
 *
 * @description
 * Для получения ключей используется два источника:
 * 1. LocalStorage (primary) – локальный источник
 * 2. Backend (fallback) – внешний источник
 *
 * В случае, если запрашиваемые namespace не будет получен из primary-источника,
 * сервис сделает запрос в fallback-источник и закеширует данные в primary-источник.
 */
export const createInstance = ({
  loadPath,
  requestOptions,
  ...localStorageOptions
}: InstanceFactoryOptions) => {
  const httpApiInstance = HttpApi.createInstance({
    loadPath,
    requestOptions,
  });
  const localStorageInstance = LocalStorage.createInstance(localStorageOptions);

  return new Chained(null, {
    backends: [localStorageInstance, httpApiInstance],
  });
};
